import * as React from 'react';
import * as mobxReact from 'mobx-react';
import { injectIntl, IntlShape } from 'react-intl';
import DefaultButton from '../../../../../global/default-button/default-button';
import { CommonModal } from '../../../../../global/modal/common/common-modal';
import { DefaultCloseModalButton } from '../../../../../global/modal/common/common-close-modal-buttons';
import { MeetingsListViewModel } from '../../meetings-list.viewmodel';
import { UploadMeetingsFormPresentation } from './_upload-meetings-form/upload-meetings-form.presentation';

interface IProps {
    vm: MeetingsListViewModel;
    intl: IntlShape;
}

const UploadMeetingsModal = injectIntl(mobxReact.observer((props: IProps) => {
    const { intl } = props;

    return (props.vm && <CommonModal
        title={intl.formatMessage({
            id: 'oe.schedule.upload',
            defaultMessage: 'Upload Schedule',
            description: 'Label text'
        })}
        isOpen={props.vm.getIsFormShown()}
        onRequestClose={props.vm.hideAndResetForm}
        footer={(
            <div className='buttons-block buttons-block--from-right'>
                <DefaultButton
                    text={intl.formatMessage({
                        id: 'oe.meetings.upload',
                        defaultMessage: 'Upload Meetings',
                        description: 'Button label'
                    })}
                    modifier={['fat', 'confirm-safe']}
                    onClick={props.vm.handleUploadMeetingsClick}
                />
                <DefaultCloseModalButton />
            </div>
        )}
    >
        <UploadMeetingsFormPresentation vm={props.vm} />
    </CommonModal>);
}));

export { UploadMeetingsModal };
